module.exports = __webpack_public_path__ + "static/media/word2.fcfe5371.jpg";